import { type CalenderAppointmentsSearchFilters } from "./appointmentFilterReducer";

export const selectEmail = (state: CalenderAppointmentsSearchFilters) => {
  if (state.tableView === "TEAM") {
    return state.teamCalendar.emailId?.length
      ? state.teamCalendar.emailId
      : undefined;
  } else if (state.tableView === "OVERVIEW") {
    return state.overviewCalendar.emailId;
  } else {
    return state.agendaCalendar.emailId;
  }
};

export const selectTeam = (state: CalenderAppointmentsSearchFilters) => {
  if (state.tableView === "TEAM" && state.teamCalendar.selection) {
    return state.teamCalendar.selection.teamId;
  }
  return undefined;
};
